import {useEffect, useRef, useState} from 'react'
import {api} from '../../lib/api.js'
import {useSessionGeneration} from '../../lib/useSessionGeneration.js'
import {createFreshAuthorityController, freshAuthorityInitial} from './freshAuthorityState.js'
import styles from './ChampionshipDrawer.module.css'

const text = value => typeof value === 'string' || typeof value === 'number' ? String(value) : 'Not reported'
export function ChampionshipAuthorityView({state, onRead}) {
  const data = state.data
  return <details className={styles.section}>
    <summary>Fresh account authority</summary>
    <p>Read the current championship assignment and associated companies before creating artwork. This does not create a job or change an assignment.</p>
    <button className="btn" type="button" disabled={state.phase === 'loading'} onClick={onRead}>{state.phase === 'loading' ? 'Reading current authority…' : 'Read fresh account authority'}</button>
    {state.error && <p role="alert">{state.error} Assignment and company membership remain unknown, not Unassigned or empty.</p>}
    {data && <div>
      <p>Fresh response received {text(state.receivedAt)}. Championship {text(data.id)}. Scope granted by the current server roster and canonical assignment.</p>
      <p>Current record.sr_assigned_rep: {typeof data.record.sr_assigned_rep === 'string' ? data.record.sr_assigned_rep || '(explicitly empty on current record)' : 'Not reported by server'}</p>
      {data.authority.heldReason && <p role="alert">Held: {text(data.authority.heldReason)}. This read does not clear that hold.</p>}
      {data.companiesError ? <p role="alert">Associated company read failed: {text(data.companiesError)}. This is not an empty company list.</p> : Array.isArray(data.companies) ? data.companies.length ? <ul>{data.companies.map((company, index) => <li key={company.companyId || index}>{company.name || company.properties?.name ? <>{text(company.name || company.properties?.name)} · </> : null}Company {text(company.companyId)}</li>)}</ul> : <p>The fresh successful read returned no associated companies.</p> : <p>Associated companies are unavailable, not an empty list.</p>}
      <p>This read is not permission to create, render, enroll or send. Any later action rechecks current authority.</p>
    </div>}
  </details>
}
function SelectedAuthority({id}) {
  const [state, setState] = useState(freshAuthorityInitial)
  const controller = useRef(null)
  useEffect(() => {
    const current = createFreshAuthorityController({id, read: api.championshipRecord, onChange: setState})
    controller.current = current
    return () => { current.dispose(); controller.current = null }
  }, [id])
  return <ChampionshipAuthorityView state={state} onRead={() => controller.current?.load()}/>
}
export default function ChampionshipAuthorityPanel({champ}) {
  const generation = useSessionGeneration()
  if (!champ?.id || champ.sourceType) return null
  return <SelectedAuthority key={JSON.stringify([String(champ.id), generation])} id={champ.id}/>
}
